import React, {useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText} from "@material-ui/core";
import { ApplicationUser } from '../../../entities/ApplicationUser';
import { AccountService } from '../../../services/AccountService';
import { ServerResponse } from '../../../services/server/OldWebClient';
import { EventTracking } from '../../../utilities/Tracking/EventTracking';
import { useAuthenticatedUser } from '../../../utilities/useAuthenticatedUser';

interface Props {
    openCancelDialog: boolean;
    toggleCancelDialog: () => void;
    toggleSpecialOfferDialog: () => void;
    onSubscriptionChanged: (updatedUser:ApplicationUser) => void;
    toggleShowErrorMessage: () => void;
    setErrorMessage: (message:string) => void;
}

export function CancelSubscriptionDialog(props:Props) {
    const {  openCancelDialog, toggleCancelDialog, onSubscriptionChanged, toggleSpecialOfferDialog, setErrorMessage, toggleShowErrorMessage } = props;
    const user = useAuthenticatedUser();

    const [disabled, setdisabled] = useState<boolean>(false);

    const onCancelSubscription = async () => {
        if(user.makerSubscription?.currentPlanName === 'Annual - Discount'){
            setdisabled(true);
            let applicationUserResponse = await AccountService.cancelMakerSubscriptionAtEndOfTerm();
            if (ServerResponse.isSuccess(applicationUserResponse)) {
                onSubscriptionChanged(applicationUserResponse.data);
                EventTracking.Subscribe.onCancelSubscription();
            } else if(ServerResponse.isError(applicationUserResponse)){
                setErrorMessage(applicationUserResponse.message)
                toggleShowErrorMessage();
            }     
            setdisabled(false);
            toggleCancelDialog()
        } else {
            toggleCancelDialog();
            toggleSpecialOfferDialog();
        }
    }

    return (
        <Dialog open={openCancelDialog} onClose={toggleCancelDialog} >
            <DialogTitle>Are you sure you want to cancel your subscription to Sermon Maker Standard?</DialogTitle>
            <DialogContent>
                {
                    user.makerSubscription
                    &&
                    user.makerSubscription.serviceStopDate
                    &&
                    <DialogContentText>Your access to Sermon Maker Standard will continue through {new Date(user.makerSubscription.serviceStopDate).toLocaleDateString()}.</DialogContentText>
                }
                <br />
                <DialogContentText>
                    You will continue to have access to your sermons, assets and uploaded content.
                    However, as a Sermon Maker Free user, you will no longer be able to use Standard features or upload premium content.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleCancelDialog} disabled={disabled} color="primary">
                    No
                </Button>
                <Button onClick={onCancelSubscription} disabled={disabled} color="primary">
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}
